export const TUS_CATEGORY_FOLDER_FILES = 'files/folders';
